// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__tlIsZ","swiper":"Carousel_swiper__m2JmY","slide":"Carousel_slide__ycT5O"};